import { BlogGrid } from "components/BlogGrid";
import { Button } from "components/Button";
import { EXTRALARGE, GREY, WHITE } from "shared/variables";
import { getSingle, getDocs } from "shared/prismic";
import { Intro } from "components/Intro";
import { MaxWidth } from "components/MaxWidth";
import { NewsletterFormBlock } from "components/NewsletterForm";
import { OverlapArea } from "components/OverlapArea";
import { Page } from "components/Page";
import { SpacingSection } from "components/SpacingSection";
import { useState } from "react";

const blogsPerPage = 12;

export async function getStaticProps({ preview = null, previewData }) {
  const doc = await getSingle({ previewData, type: "blog_overview" });
  const items = await getDocs({ previewData, type: "blog_detail" });
  return { props: { doc, items, preview, title: "Blog" } };
}

export const BlogOverviewPage = ({ doc, items, preview, title }) => {
  const [page, setPage] = useState(1);
  const { seo_title, seo_description, seo_image, intro } = doc.data;
  const renderButton = page * blogsPerPage < items.length;

  const visibleItems = items
    .sort((a, b) =>
      a.first_publication_date > b.first_publication_date ? -1 : 1
    )
    .slice(0, page * blogsPerPage);

  return (
    <Page
      description={seo_description}
      image={seo_image}
      preview={preview}
      title={seo_title}
      withLightFooter
    >
      <OverlapArea>
        <MaxWidth>
          <Intro color={WHITE} title={title} text={intro} />
        </MaxWidth>
      </OverlapArea>
      <SpacingSection onlyBottom size={EXTRALARGE}>
        <MaxWidth size={EXTRALARGE}>
          <BlogGrid items={visibleItems} />
          {renderButton && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: 60,
              }}
            >
              <Button color={GREY} onClick={() => setPage(page + 1)}>
                Toon meer
              </Button>
            </div>
          )}
        </MaxWidth>
      </SpacingSection>
      <NewsletterFormBlock />
    </Page>
  );
};

export default BlogOverviewPage;
